import { useEffect } from "react";
import type { AppProps } from "next/app";
import { GlobalStyles, handleTheme } from "common/theme/Styles";
import { ThemeProvider } from "styled-components";
import ErrorBoundary from "Components/ErrorBoundary";
import { DefaultSeo } from "next-seo";
import { AuthContextProvider } from "common/context/Auth";
import { Router, useRouter } from "next/router";
import { AdsProvider } from "common/ads/AdsProvider";
import { PreviewContextProvider } from "common/context/Preview";
import "../common/theme/react-draft-wysiwyg.css";
import "../common/theme/gallery.css";
import "./styles/globals.css";
import { PublicationContextProvider } from "common/context/Publication";
import NProgress from "nprogress";
import { publicationsConfig } from "common/config/publications";
import { DataLayerProvider } from "common/context/DataLayer";
import Head from "next/head";

Router.events.on("routeChangeStart", (url) => {
  NProgress.start();
});
Router.events.on("routeChangeComplete", () => NProgress.done());
Router.events.on("routeChangeError", () => NProgress.done());

function MyApp({ Component, pageProps }: AppProps) {
  const router = useRouter();

  const publication = pageProps.publication
    ? pageProps.publication
    : "abergavennychronicle.com";

  useEffect(() => {
    console.log(window !== undefined && window.location.hostname);
    console.log({ state: process.env.NEXT_PUBLIC_ENV_STATE });

    const handleRouteChange = (url: URL) => {
      // gtag.pageview(url);
    };

    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);

  return (
    <>
      <Head>
        <meta name="view-transition" content="same-origin" />
      </Head>
      <GlobalStyles />
      <ThemeProvider theme={handleTheme(publication)}>
        <ErrorBoundary>
          <DefaultSeo
            openGraph={{
              type: "website",
              locale: "en",
              url: publicationsConfig[publication].url,
              site_name: publicationsConfig[publication].pub,
            }}
          />
          <PublicationContextProvider pub={publication}>
            <AuthContextProvider>
              <PreviewContextProvider>
                <AdsProvider>
                  <DataLayerProvider>
                    <Component {...pageProps} />
                  </DataLayerProvider>
                </AdsProvider>
              </PreviewContextProvider>
            </AuthContextProvider>
          </PublicationContextProvider>
        </ErrorBoundary>
      </ThemeProvider>
    </>
  );
}
export default MyApp;
